import { ErrorBoundary } from '@ori/checkout-utils';
import { LoggerProvider } from '@ori/logger';
import type { FC } from 'react';

import { BasketProvider } from '../components';
import { APP_NAME } from '../constants';
import { ConfigurationProvider } from '../contexts';
import { mainLogger } from '../logger';
import type { ClientAppConfig } from '../types';
import { ApiProvider } from './ApiProvider';

export const BasketProviderController: FC<ClientAppConfig> = (configuration) => (
  <ErrorBoundary
    appName={APP_NAME}
    logger={mainLogger}
  >
    <LoggerProvider logger={mainLogger}>
      <ApiProvider>
        <ConfigurationProvider value={configuration}>
          <BasketProvider />
        </ConfigurationProvider>
      </ApiProvider>
    </LoggerProvider>
  </ErrorBoundary>
);
